import { render, staticRenderFns } from "./ExpressType.vue?vue&type=template&id=a8925b84&scoped=true"
import script from "./ExpressType.vue?vue&type=script&lang=js"
export * from "./ExpressType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8925b84",
  null
  
)

export default component.exports